import { GiftCardBalanceApply } from 'components/business/checkout/GiftCardBalanceApply';
import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import React, { FunctionComponent } from 'react';

const rootStyles = ({ spacing, colors, borderRadius }: Theme) => css`
  background-color: ${colors.bgLight};
  border: 1px solid ${colors.borderDefault};
  border-radius: ${borderRadius[100]};
  padding: ${spacing(2.5)}px ${spacing(3)}px;
  margin-bottom: ${spacing(3)}px;
`;

interface GiftCardBalanceWrapperProps {
  amountCents: number;
  businessSupportsGiftCards: boolean;
  onUseBalanceChange(event: React.ChangeEvent<HTMLInputElement>, checked: boolean): void;
  useGiftCardBalance: boolean;
}

export const GiftCardBalanceWrapper: FunctionComponent<GiftCardBalanceWrapperProps> = ({
  amountCents,
  businessSupportsGiftCards,
  onUseBalanceChange,
  useGiftCardBalance,
}) => {
  return (
    <div css={rootStyles}>
      <Typography variant="body02Strong" component="h2" mb={1}>
        Your gift card balance
      </Typography>
      {businessSupportsGiftCards ? (
        <GiftCardBalanceApply
          amountCents={amountCents}
          onChange={onUseBalanceChange}
          useGiftCardBalance={useGiftCardBalance}
        />
      ) : (
        <Typography variant="body02">
          Your gift card balance cannot be used at this business.
        </Typography>
      )}
    </div>
  );
};
